import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionStorageService } from 'src/app/authentication/storage/permission-storage.service';
import { TokenStorageService } from 'src/app/authentication/storage/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private tokenStorageService : TokenStorageService,
    private permissionStorage : PermissionStorageService
    ) {
  }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.tokenStorageService.getToken()){
        return this.router.createUrlTree(["/auth"]);
      } 
      else if(!this.permissionStorage.getPermissions()?.includes(route.data['permission'])){
        return this.router.createUrlTree(["/403"]);
      }
      else {
        return true
      }

      // return true
  }
  
}
